export const AUTHORIZATION_REQUIRED = 'AUTHORIZATION_REQUIRED';
export const UNDEFINED_ERROR = 'UNDEFINED_ERROR';
export const RESET_UNDEFINED_ERROR = 'RESET_UNDEFINED_ERROR';
export const RESET_MESSAGE = 'RESET_MESSAGE';
